/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {BannerEl} from 'common/components/banner';
import {BannerSize, BannerTheme, BannerType} from 'common/components/banner/types';
import {numberInUSD} from 'common/util';
import {BillingCredit, OrgPlanInfo} from 'media/js/pricing/api/types';
import {DisplaySize, DisplayType, Placement} from 'common/components/tooltip/types';
import {TooltipEl} from 'common/components/tooltip';

import marketingTooltipStyleOverride from '../common/marketing-tooltip.inline.styl';
import marketingBannerStyleOverride from './marketing-banner.inline.styl';

export const banners = (
  isAnnualDowngrade: boolean,
  credits: BillingCredit[],
  org: OrgPlanInfo,
  isMP2023style = false,
) => {
  const creditTotal = credits.reduce((balance, credit) => balance + credit.remainingBalance, 0);
  const {orgId} = org || {};

  return (
    <>
      {!isMP2023style && isAnnualDowngrade && (
        <BannerEl
          attrs={{
            theme: BannerTheme.Warn,
            type: BannerType.Embedded,
            'body-text': `Immediate plan changes are only allowed for increased events or add-on changes.`,
            'header-text': `Your plan changes will take effect at the end of your current plan term.`,
          }}
        />
      )}
      {creditTotal > 0 && (
        <BannerEl
          attrs={{
            theme: BannerTheme.Success,
            type: BannerType.Embedded,
            'style-override': isMP2023style && marketingBannerStyleOverride,
            'body-text':
              `You have ${numberInUSD(creditTotal)} in credits` +
              `${
                credits.length === 1 ? `, valid until ${credits[0].endDate}` : ``
              }. [View credit details](/settings/org/${orgId}/plan)`,
          }}
        />
      )}
    </>
  );
};

export const annualDowngradeWarningBanner = (isAnnualDowngrade: boolean) => {
  return (
    isAnnualDowngrade && (
      <div sel='.downgrade-warning'>
        <TooltipEl
          attrs={{
            placement: Placement.Left,
            size: DisplaySize.Medium,
            type: DisplayType.Error,
            'style-override': marketingTooltipStyleOverride,
          }}
        >
          Your plan changes will take effect at the end of your current plan term. Immediate changes only permitted for
          increased MTUs or add-on changes.
        </TooltipEl>
        <BannerEl
          attrs={{
            theme: BannerTheme.Warn,
            type: BannerType.Embedded,
            size: BannerSize.ExtraSmall,
            'body-text': `Changes take effect at term's end`,
            'style-override': marketingBannerStyleOverride,
          }}
        />
      </div>
    )
  );
};
